import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

export function BasicOperatorItem({ text }) {
  const colors = useContext(ColorThemeContext);
  return (
    <View padding={1}>
      <MBTextBody1 color={colors.foregroundActive}>{text}</MBTextBody1>
    </View>
  );
}
